import { useEffect, useState } from "react";
import { authClient } from "../client/auth-client";

export const useIsLoggedInWithStoredToken = (): boolean => {
  const session = authClient.useSession();
  const [hasStoredAuthToken, setHasStoredAuthToken] = useState(false);

  useEffect(() => {
    let isCancelled = false;

    void authClient.getAuthToken().then((token) => {
      if (!isCancelled) {
        setHasStoredAuthToken(Boolean(token));
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [session.data?.user]);

  return !!session.data?.user && hasStoredAuthToken;
};
